<template>
  <div>
    <el-badge :is-dot="dot">
      <i class="el-icon-bell"></i>
    </el-badge>
  </div>
</template>

<script>
import {getCountNotice} from '../../api/notice'

export default {
  data () {
    return {
      dot: false
    }
  },
  methods: {
    getCount () {
      getCountNotice().then((res) => {
        if (res) {
          if (res.data > 0) {
            this.dot = true
          }
        }
      })
    }
  },
  mounted () {
    this.getCount()
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Notice/index.vue